import * as request from '@/utils/request'
import { param } from 'jquery';

let api = '';

// 发送验证码  
// param {phoneNumber: String}
export const sendSmsCode = (params) => request.post(api + '/sendSMSCode', params)

// 验证码注册
// param {phoneNumber: String, code: String, password: String}
export const registerUser = (params) => request.post(api + '/registerUser', params)

// 验证码登录
// param {phoneNumber: String, code: String}
export const loginByCode = (params) => request.post(api + '/signinBySMSCode', params)

// 密码登录
// param {phoneNumber: String, password: String}
export const loginByPassword = (params) => request.post(api + '/signinByPassword', params)

// 检查用户登录状态

export const checkIsLogined = () => request.post(api + '/checkUser')


// 忘记密码
export const forgetPassword = (params) => request.post(api + '/changeUserPasswordBySMSCode', params)


// 退出登录
export const logout = () => request.post(api + '/logout')

// 获取图谱
export const getIndexGraph = () => request.post(api + '/ShowkgIndex')


// 服务条款
export const getServiceItems = () => request.get(api + '/ServiceTerms')

// 隐私条款
export const getPrivatePolicy = () => request.get(api + '/PrivacyPolicy')

// 会员协议
export const getVipService = () => request.get(api + '/VipService')

// 自动续费协议
export const getContinueService = () => request.get(api + '/ContinueService')

// 技术架构

export const getArchitecture = () => request.get(api + '/Architecture')
